import React from "react";
import "./linkHL.css";

/**
 * @param {*} props
 * @return {*}
 * @status no delete
 * @description Standard link (anchor) component in the a3 framework
 */
const LinkHLPure = (props) => {
  const {
    text, // Text in link
    href, // Href for the anchor, defaults to "#"
    onClick, // Function onClick link
    disabled, // True to disable the link
    colorScheme, // "primary" | "secondary" | "neutral"
    ...otherProps
  } = props;

  const handleClick = (event) => {
    if (disabled) return
    event.preventDefault()
    onClick && onClick(event)
  };

  return (
    <a
      href={href || "#"}
      className={`linkHLPure ${colorScheme ? `linkHLPure-${colorScheme}` : "linkHLPure-primary"} ${disabled ? "disabled" : ""}`}
      onClick={handleClick}
      {...otherProps}
    >
      {text}
    </a>
  );
};

export { LinkHLPure as default };
